import React from "react";
import { Loader2, RefreshCw } from "lucide-react";

export const CatalogLoadState = ({ loading, error, onRetry, id, message = "Produkte werden geladen…" }) => {
  if (loading) return (
    <div className="flex items-center gap-3 py-8" role="status" aria-live="polite" data-testid={`${id}-loading`}>
      <Loader2 className="w-5 h-5 animate-spin shrink-0 text-brand-yellow" aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
  if (!error) return null;
  return (
    <div className="rounded-2xl border border-hair bg-white text-ink p-6 md:p-8" role="alert" data-testid={`${id}-error`}>
      <p className="font-heading text-xl mb-2" data-testid={`${id}-error-title`}>Einen Moment bitte.</p>
      <p className="text-sm text-ink-soft leading-relaxed" data-testid={`${id}-error-message`}>Die Verbindung ist gerade kurz unterbrochen. Bitte versuchen Sie es erneut, Ihre Auswahl bleibt erhalten.</p>
      <button type="button" onClick={onRetry} className="btn-accent mt-5" data-testid={`${id}-retry`}>
        <RefreshCw className="w-4 h-4" aria-hidden="true" /> Erneut versuchen
      </button>
    </div>
  );
};
